import SurveyStepEmplacementContainer from "./SurveyStepEmplacementContainer";
export default SurveyStepEmplacementContainer;



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepEmplacement/index.js